// src/components/NotificationInit.tsx

import { useLocation } from "../../../hooks/useLocation";


export const LocationInit = () => {
    useLocation();
    return null;
};